import { motion } from "framer-motion";
import { lineMaskContainer, lineMaskItem } from "./Reveal";

export const PageHeader = ({ eyebrow, title, subtitle, image }) => {
  return (
    <section
      data-testid="page-header"
      className="relative overflow-hidden border-b border-steel/20 bg-aero-surface"
    >
      {image && (
        <div className="absolute inset-0">
          <img src={image} alt="" className="h-full w-full object-cover opacity-25" />
          <div className="absolute inset-0 bg-gradient-to-t from-aero-surface via-aero-surface/80 to-aero-surface/60" />
        </div>
      )}
      <div className="blueprint-grid absolute inset-0 opacity-30" />
      <div className="relative mx-auto max-w-[1400px] px-5 pb-16 pt-36 sm:px-8 sm:pb-20 sm:pt-44">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className="mb-5 flex items-center gap-3"
        >
          <span className="h-px w-10 bg-saffron" />
          <span className="font-heading text-xs uppercase tracking-[0.28em] text-saffron">
            {eyebrow}
          </span>
        </motion.div>

        <motion.h1
          variants={lineMaskContainer}
          initial="hidden"
          animate="show"
          className="max-w-4xl font-heading text-5xl font-black uppercase leading-[0.95] tracking-tighter text-ink sm:text-6xl lg:text-7xl"
        >
          <span className="block overflow-hidden py-[0.04em]">
            <motion.span variants={lineMaskItem} className="block">
              {title}
            </motion.span>
          </span>
        </motion.h1>

        {subtitle && (
          <motion.p
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.4 }}
            className="mt-6 max-w-2xl font-body text-base leading-relaxed text-steel sm:text-lg"
          >
            {subtitle}
          </motion.p>
        )}
      </div>
    </section>
  );
};
